<template>
    <div class="movie-filter">

      <dropdown :options="options.occasion" placeHolder="Alle Sprachversionen" @option="onSelectOccasion"></dropdown>
      <dropdown @option="onSelectMonth" :options="options.months" class="kw"  :placeHolder="'Monate'" placeholderShort="Monate"></dropdown>
      <dropdown @option="onSelectSeason" :options="options.seasons" :placeHolder="filter.season && filter.season !== options.seasons[options.seasons.length - 1] ? filter.season.toString() : 'Dieses Jahr'"></dropdown>

      <div class="list">
        <span>Anordnen</span>
        <img :class="{enabled:!viewModeGrid}" @click="emit('filter', {view:'list'});viewModeGrid=false" src="/static/img/Listenansicht.png" alt="Listenansicht" />
        <img :class="{enabled:viewModeGrid}" @click="emit('filter', {view:'grid'});viewModeGrid=true" src="/static/img/Coveransicht.png" alt="Kachelansicht"/>
      </div>
    </div>
</template>

<script>
import Dropdown from '@/components/elements/Dropdown.vue'
import Checkbox from '@/components/elements/Checkbox.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import scss from '@/sass/custom/vue-slider.scss'

export default {
  components: { Dropdown, VueSlider, Checkbox },
  props: ['options', 'filter'],
  data () {
    return {
      viewModeGrid: true,
      selectedValues: [this.options.period[0], this.options.period[this.options.period.length - 1]]
    }
  },
  methods: {
    emit: function (event, option) {
      this.$event.$emit('userinteraction', {item: 'filter', from: this.$route.path, label: option})
      this.$event.$emit(event, option)
    },
    OnSelectGenre: function (option) {
      this.emit('filter', {genre: option})
    },
    onSelectOccasion: function (option) {
      this.emit('filter', {occasion: option})
    },
    onSelectMonth: function (value) {
      this.emit('filter', {month: value})
    },
    onSelectSeason: function (value) {
      this.emit('seasonChange', value)
    }
  },
  mounted: function () {
    let year = this.$route.params.year;
    if (year) {
      this.filter.season = year
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.movie-filter {
  width:90%;
  margin-left:auto;
  position: absolute;
  top:-2.74em;
  right:0;
  background-color:inherit;
  display: flex;
  padding-top:0;
  padding-bottom:0.5em;
  z-index:10;
  justify-content: space-between;
  box-sizing: border-box;

  @include for-size(phone-only) {
    position: relative;
    flex-direction: column;
    width:100%;
    margin:0;
  }
  @include for-size(tablet-portrait-up) {
    flex-direction: row;
    width:90%;
    flex-wrap: wrap;
    padding: 0 10% 0.5em 0;
    & > .dropdown {
       width:50%;
    }
  }
  @include for-size(tablet-landscape-up) {
    flex-direction: row;
    width:100%;
    flex-wrap: nowrap;
    padding-top:0;
    padding-bottom:0.5em;
    & > .dropdown {
       width:100%;
    }
  }
  @include for-size(desktop-up) {
    width:90%;
    margin-left:auto;
  }

  .list{
    display: flex;
    justify-content: space-between;
    align-items:center;
    margin-right:1%;
    font-size:1em;
    @include for-size(phone-only) {
      display:none;
    }
    @include for-size(tablet-portrait-up) {
      position: absolute;
      right:0;
      top:1em;
    }
    @include for-size(tablet-landscape-up) {
      position: initial;
    }
    @include for-size(desktop-up) {
      font-size: 0.8em;
      margin-left:3em;
    }

    &>span{
      font-family: $font-main;
      font-weight: 700;
      font-style: normal;
      text-decoration: none;
      padding: 1em 0.5em 1em 0.5em;
      display: block;
      white-space: nowrap;
      text-align:right;
      font-size: 1em;
      @include for-size(tablet-portrait-up) {
        display:none;
      }
      @include for-size(tablet-landscape-up) {
        display:block;
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: none;
      }
    }
    &>img{
      width: 1.5em;
      height: 1.5em;
      margin: 0 .5em;
      cursor: pointer;
      opacity: 0.5;
      transition: all .5s ease;
      &.enabled{
        opacity: 1;
      }
      &:hover{
        //transform: scale(1.2);
      }
    }
  }
}

  /deep/ li.custom{
      border-left: 1px solid #e0e0e0;
      border-right: 1px solid #e0e0e0;
      &:last-of-type{
        border-bottom: 1px solid #e0e0e0;
      }
    padding: 3em 2em 2em 2em;
    &:hover {
      background-color:initial;
      color: initial;
    }
  }
  /deep/ li.checkbox{
    padding: 1.5em 1em 1.5em 1.5em;
    background-color:$grey-fill;
    label{
      white-space: nowrap;
      font-size: 1em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modules/Program/Filters.vue